module.exports = __webpack_public_path__ + "static/media/stijn-bessem-dna-placeholder-01@2x.2862cd9c.png";